type Point = { clientX: number; clientY: number };
type Handlers = { start: (point: Point) => void; move: (point: Point) => void; end: () => void };

/** iOS 12 没有 Pointer Events；原生非 passive 触摸监听避免签字时滚动页面。 */
export function bindLegacySignatureInput(canvas: HTMLCanvasElement, handlers: Handlers) {
  let touchId: number | null = null;
  const prevent = (event: TouchEvent) => { if (event.cancelable) event.preventDefault(); };
  const touchStart = (event: TouchEvent) => {
    if (touchId !== null || !event.changedTouches.length) return;
    prevent(event);
    const touch = event.changedTouches[0];
    touchId = touch.identifier;
    handlers.start(touch);
  };
  const touchMove = (event: TouchEvent) => {
    if (touchId === null) return;
    prevent(event);
    for (let i = 0; i < event.changedTouches.length; i += 1) {
      if (event.changedTouches[i].identifier === touchId) handlers.move(event.changedTouches[i]);
    }
  };
  const touchEnd = (event: TouchEvent) => {
    for (let i = 0; i < event.changedTouches.length; i += 1) {
      if (event.changedTouches[i].identifier === touchId) {
        prevent(event);
        touchId = null;
        handlers.end();
      }
    }
  };
  const mouseStart = (event: MouseEvent) => { if (event.button === 0 && touchId === null) handlers.start(event); };
  const mouseMove = (event: MouseEvent) => { if (touchId === null) handlers.move(event); };
  const mouseEnd = () => { if (touchId === null) handlers.end(); };
  const listeners: [string, EventListener][] = [
    ['touchstart', touchStart as EventListener], ['touchmove', touchMove as EventListener],
    ['touchend', touchEnd as EventListener], ['touchcancel', touchEnd as EventListener],
    ['mousedown', mouseStart as EventListener], ['mousemove', mouseMove as EventListener],
    ['mouseup', mouseEnd], ['mouseleave', mouseEnd],
  ];
  for (const [type, listener] of listeners) canvas.addEventListener(type, listener, { passive: false });
  return () => {
    for (const [type, listener] of listeners) canvas.removeEventListener(type, listener);
    handlers.end();
  };
}
